// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__22EBt","language-container":"style_language-container__2begU","language":"style_language__28kvF","selected":"style_selected__3wGAX"};